import * as R from 'ramda'
import { formatMoneyWithThousandSeparator } from './helper'


export const compileSetTable = (monthList) => {
    const table = []
    table.push(compileNetRevenuesFromSet(monthList))
    table.push(compileProspectCreated(monthList))
    table.push(compileSetOrders(monthList))
    table.push(compileSetsShipment(monthList))
    table.push(compileSetOrderCashFlow(monthList))
    table.push(compileSetAverageSellingPrice(monthList))
    table.push(compileRefundedSetOrders(monthList))
    table.push(compileRefundedSetOrdersAmount(monthList))
    table.push(compileCannotBeTreatedSetOrders(monthList))
    table.push(compileCannotBeTreatedSetOrdersAmount(monthList))
    table.push(compileCanceledSetOrders(monthList))
    table.push(compileCanceledSetOrdersAmount(monthList))
    return table
}

// prospectCreated

const compileProspectCreated = (monthList) => {
    const result = []
    result.push('Prospect created')
    R.forEach(month => {
        result.push(month.prospectCreated)
    }, monthList)
    return result
}


const compileNetRevenuesFromSet = (monthList) => {
    const result = []
    result.push('Net Revenues from Kit Operations')
    R.forEach(month => {
        const amount = month.setCashFlow_net - month.setCashFlowCanceled_net - month.setCashFlowCannotBeTreated_net
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}

const compileSetOrders = (monthList) => {
    const result = []
    result.push('Kit Orders (#)')
    R.forEach(month => {
        result.push(month.setCashFlow_count)
    }, monthList)
    return result
}

const compileSetsShipment = (monthList) => {
    const result = []
    result.push('Kit Shipments (#)')
    R.forEach(month => {
        result.push(month.setShipped)
    }, monthList)
    return result
}


const compileSetOrderCashFlow = (monthList) => {
    const result = []
    result.push('Kit Orders (net)')
    R.forEach(month => {
        result.push(formatMoneyWithThousandSeparator(month.setCashFlow_net))
    }, monthList)
    return result
}

const compileSetAverageSellingPrice = (monthList) => {
    const result = []
    result.push('Kit - Average Selling Price (gross)')
    R.forEach(month => {
        const amount = month.setCashFlow_brut / month.setCashFlow_count
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}

const compileRefundedSetOrders = (monthList) => {
    const result = []
    result.push('Refunded Orders (#)')
    R.forEach(month => {
        const amount = month.setCashFlowCannotBeTreated_count + month.setCashFlowCanceled_count
        result.push(amount)
    }, monthList)
    return result
}

const compileRefundedSetOrdersAmount = (monthList) => {
    const result = []
    result.push('Refunded Orders (net)')
    R.forEach(month => {
        const amount = month.setCashFlowCannotBeTreated_net + month.setCashFlowCanceled_net
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}

const compileCannotBeTreatedSetOrders = (monthList) => {
    const result = []
    result.push('Cannot be treated (#)')
    R.forEach(month => {
        const amount = month.setCashFlowCannotBeTreated_count
        result.push(amount)
    }, monthList)
    return result
}

const compileCannotBeTreatedSetOrdersAmount = (monthList) => {
    const result = []
    result.push('Cannot be treated (net)')
    R.forEach(month => {
        const amount = month.setCashFlowCannotBeTreated_net
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}


const compileCanceledSetOrders = (monthList) => {
    const result = []
    result.push('Other (#)')
    R.forEach(month => {
        const amount = month.setCashFlowCanceled_count
        result.push(amount)
    }, monthList)
    return result
}

const compileCanceledSetOrdersAmount = (monthList) => {
    const result = []
    result.push('Other (€)')
    R.forEach(month => {
        const amount = month.setCashFlowCanceled_net
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/set-table.js